import liff from '@line/liff';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT || 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
});

const getLoginRedirectUri = () => window.location.href;

api.interceptors.request.use(
  async (config) => {
    try {
      await liff.ready;
      const token = liff.getAccessToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error retrieving LIFF token:', error);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      try {
        liff.login({ redirectUri: getLoginRedirectUri() });
      } catch (loginError) {
        console.error('Failed to redirect to LINE login:', loginError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
